import { createGlobalStyle } from "styled-components";

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 98px 16px;
    }
    .row.px-0.mx-0 > .container > div > div > div {
      padding-top: 0 !important;
    }
  }
`;
